/* SOLINO : ajustements de comportement que le theme ne sait pas regler.
   Ce fichier nous appartient. Il s'ajoute au theme sans modifier aucun de ses
   scripts, qu'une mise a jour de Victory remplacerait. */
(function () {
  "use strict";

  /* Widget "Trend products" : le script du theme ouvre la premiere bulle des
     le chargement sur ordinateur, ce qui masque la canette qu'elle designe.
     On referme tout, pour ne laisser que les pastilles rondes. */
  function refermerLesBulles() {
    document.querySelectorAll(".js-trend-products-section").forEach(function (section) {
      section.querySelectorAll(".js-trend-products-spot").forEach(function (point) {
        point.classList.remove("is-active");
        point.setAttribute("aria-expanded", "false");
      });
      section.querySelectorAll(".js-trend-product-popup").forEach(function (bulle) {
        bulle.classList.remove("is-active");
        bulle.removeAttribute("data-first-render");
      });
    });
  }

  /* Carrousel des planches de degustation : le defilement horizontal existe en
     CSS, mais rien ne l'annonce et la molette verticale ne le declenche pas. On
     ajoute les fleches et les puces, sans toucher au defilement lui-meme. */
  function equiperLesCarrousels() {
    document.querySelectorAll(".solino-tete__droite").forEach(function (colonne) {
      var piste = colonne.querySelector(".solino-tete__carrousel");
      var puces = colonne.querySelector(".js-solino-carrousel-puces");
      var prec = colonne.querySelector(".js-solino-carrousel-prec");
      var suiv = colonne.querySelector(".js-solino-carrousel-suiv");
      if (!piste || !puces || puces.childElementCount) return;

      var planches = Array.prototype.slice.call(piste.children);
      if (planches.length < 2) return;

      planches.forEach(function (planche, i) {
        var puce = document.createElement("button");
        puce.type = "button";
        puce.className = "solino-tete__puce";
        puce.setAttribute("aria-label", "Planche " + (i + 1));
        puce.addEventListener("click", function () {
          piste.scrollTo({ left: planche.offsetLeft - piste.offsetLeft, behavior: "smooth" });
        });
        puces.appendChild(puce);
      });

      function debutDe(planche) {
        return planche.offsetLeft - piste.offsetLeft;
      }

      function courante() {
        var meilleur = 0;
        var ecartMin = Infinity;
        planches.forEach(function (planche, i) {
          var ecart = Math.abs(debutDe(planche) - piste.scrollLeft);
          if (ecart < ecartMin) {
            ecartMin = ecart;
            meilleur = i;
          }
        });
        return meilleur;
      }

      function rafraichir() {
        var i = courante();
        Array.prototype.forEach.call(puces.children, function (puce, n) {
          puce.setAttribute("aria-current", n === i ? "true" : "false");
        });
        if (prec) prec.disabled = piste.scrollLeft <= 2;
        if (suiv) suiv.disabled = piste.scrollLeft + piste.clientWidth >= piste.scrollWidth - 2;
      }

      function glisser(sens) {
        var i = Math.min(Math.max(courante() + sens, 0), planches.length - 1);
        piste.scrollTo({ left: debutDe(planches[i]), behavior: "smooth" });
      }

      if (prec) prec.addEventListener("click", function () { glisser(-1); });
      if (suiv) suiv.addEventListener("click", function () { glisser(1); });
      piste.addEventListener("scroll", rafraichir, { passive: true });
      window.addEventListener("resize", rafraichir);
      rafraichir();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", equiperLesCarrousels, { once: true });
  } else {
    equiperLesCarrousels();
  }

  /* Ce que l'entete prend au bandeau, expose en variable CSS.
     Le bandeau d'accueil doit s'arreter pile en bas de la fenetre. Ce n'est pas
     la hauteur de l'entete qu'il faut retrancher mais la place reellement prise
     au-dessus du bandeau : Victory laisse l'entete pousser le contenu au
     chargement, puis la detache au defilement, et le bandeau remonte alors a
     zero. Mesurer sa position plutot que l'entete couvre les deux cas. */
  function mesurerEntete() {
    var bandeau = document.querySelector(".banner--solino-pleine-hauteur");
    var haut;

    if (bandeau) {
      haut = Math.round(bandeau.getBoundingClientRect().top + window.scrollY);
    } else {
      var entete = document.querySelector(".header");
      if (!entete) return;
      haut = Math.round(entete.getBoundingClientRect().height);
    }

    document.documentElement.style.setProperty("--solino-header-h", haut + "px");
  }

  mesurerEntete();
  window.addEventListener("resize", mesurerEntete);
  window.addEventListener("load", mesurerEntete);

  /* La mise en place se fait en plusieurs temps : l'entete passe sous le
     bandeau une fois les scripts du theme charges, sans toucher a sa propre
     hauteur ni provoquer de defilement. On remesure donc quelques fois le temps
     que tout se pose. */
  [100, 300, 800, 1500, 2500].forEach(function (delai) {
    setTimeout(mesurerEntete, delai);
  });

  /* L'entete grandit apres le premier rendu, le temps que Mudstone et le logo
     arrivent : mesuree une seule fois, elle vaut 85 px au lieu de 141. On la
     suit donc en continu, et on reverifie chaque fois qu'on revient en haut de
     page, ou elle peut avoir repris ou lache sa place. */
  if (window.ResizeObserver) {
    var suivi = document.querySelector(".header");
    if (suivi) {
      new ResizeObserver(mesurerEntete).observe(suivi);
    }
  }
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(mesurerEntete);
  }
  window.addEventListener("scroll", function () {
    if (window.scrollY < 4) mesurerEntete();
  }, { passive: true });

  /* Victory detache l'entete en cours de route, sans changer sa hauteur ni
     declencher de defilement : seul son attribut de classe bouge. Sans cette
     surveillance, le bandeau garde la hauteur d'avant et laisse un vide en bas. */
  if (window.MutationObserver) {
    var observee = document.querySelector(".header");
    if (observee) {
      new MutationObserver(mesurerEntete).observe(observee, {
        attributes: true,
        attributeFilter: ["class", "style"]
      });
    }
  }

  if (window.themeCore && window.themeCore.loaded) {
    refermerLesBulles();
  }
  document.addEventListener("theme:all:loaded", function () {
    setTimeout(refermerLesBulles, 0);
  }, { once: true });

  /* SOLINO : contenu du pack, suit le format choisi. 15/09/2026.
     Le snippet solino-contenu-pack rend une ligne par variante et marque la
     bonne des le rendu serveur. Ici on ne fait que suivre les changements.
     Victory ne diffuse pas d'evenement fiable sur le changement de variante :
     on lit l'entree cachee du formulaire, qui est la source de verite pour
     l'ajout au panier, et on la surveille. */
  function majContenuPack() {
    var blocs = document.querySelectorAll("[data-solino-contenu-pack]");
    if (!blocs.length) return;

    var champ = document.querySelector('form[action*="/cart/add"] [name="id"]');
    var id = champ && champ.value;
    if (!id) {
      var params = new URLSearchParams(window.location.search);
      id = params.get("variant");
    }
    if (!id) return;

    for (var i = 0; i < blocs.length; i++) {
      var lignes = blocs[i].querySelectorAll(".solino-contenu-pack__ligne");
      for (var j = 0; j < lignes.length; j++) {
        var active = lignes[j].getAttribute("data-variant") === String(id);
        lignes[j].classList.toggle("is-active", active);
      }
    }
  }

  function surveillerContenuPack() {
    if (!document.querySelector("[data-solino-contenu-pack]")) return;
    majContenuPack();

    var champ = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (champ && window.MutationObserver) {
      new MutationObserver(majContenuPack).observe(champ, {
        attributes: true,
        attributeFilter: ["value"]
      });
    }
    /* L'attribut ne bouge pas toujours : certains themes changent la propriete
       sans toucher au HTML. On ecoute donc aussi les clics sur le selecteur. */
    document.addEventListener("change", majContenuPack);
    document.addEventListener("click", function (e) {
      if (e.target.closest && e.target.closest(".product-options, .js-product-options")) {
        setTimeout(majContenuPack, 60);
      }
    });
  }

  surveillerContenuPack();
  document.addEventListener("theme:all:loaded", function () {
    setTimeout(surveillerContenuPack, 0);
  }, { once: true });
})();
